import { TextField, MenuItem, Button, FormControl, FormLabel, Switch, FormControlLabel } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useState } from "react";

const DocParsingForm = () => {
  const [docParsingFormData, setDocParsingFormData] = useState({
    file_path: "",
    file_type: "PDF",
    ocr_enabled: false,
    vlm_model_name: "",
    llm_model_name: "",
    output_format: "JSON",
  });

  const fileTypeOptions = ["PDF", "DOCX", "PNG", "JPG", "TXT"];
  const outputFormatOptions = ["JSON", "Plain Text", "CSV"];
  const vlmModelOptions = ["Model A", "Model B", "Model C"];
  const llmModelOptions = ["LLM A", "LLM B", "LLM C"];

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setDocParsingFormData({
      ...docParsingFormData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(docParsingFormData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3}>
        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>File Path</FormLabel>
            <TextField name="file_path" value={docParsingFormData.file_path} onChange={handleChange} />
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>File Type</FormLabel>
            <TextField select name="file_type" value={docParsingFormData.file_type} onChange={handleChange}>
              {fileTypeOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControlLabel
            control={<Switch name="ocr_enabled" checked={docParsingFormData.ocr_enabled} onChange={handleChange} />}
            label="Enable OCR"
          />
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Vision Language Model</FormLabel>
            <TextField select name="vlm_model_name" value={docParsingFormData.vlm_model_name} onChange={handleChange}>
              {vlmModelOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>LLM Model</FormLabel>
            <TextField select name="llm_model_name" value={docParsingFormData.llm_model_name} onChange={handleChange}>
              {llmModelOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Output Format</FormLabel>
            <TextField select name="output_format" value={docParsingFormData.output_format} onChange={handleChange}>
              {outputFormatOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        <Grid size={12} textAlign="center">
          <Button variant="contained" color="primary" type="submit">
            Submit
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default DocParsingForm;
